module.exports = __webpack_public_path__ + "static/media/more.0c0af8aa.svg";